<template>

	<div class="bios-section container-fluid" v-if="bioSection" v-bind:class="{ 'two-column': bioSection.twoColumn }">
		
		<TitleHeader v-if="bioSection.title" :subtitle="bioSection.subtitle" :title="bioSection.title"></TitleHeader>

		<div class="container">
			
			<section class="featured" v-if="bioSection.bios">

				<div class="featured-message" v-if="bioSection.summary">
					<h3 class="title">{{ bioSection.summary.title }}</h3>
					<div class="description" v-html="bioSection.summary.body"></div>
					<PrimaryCTA v-if="bioSection.summary.cta" :linkText="bioSection.summary.cta.linkText" :linkURL="bioSection.summary.cta.linkURL"></PrimaryCTA>
				</div>
				
				<div class="bio-container" :key="bio.id" v-for="bio in bioSection.bios.slice(0, 1)">
					<Bio :bio="bio"></Bio>
				</div>
			</section>

			<section class="bios" v-if="bioSection.bios">
				
				<div class="bio-container" :key="bio.id" v-for="bio in bioSection.bios.slice(1)">
					<Bio :bio="bio"></Bio>
				</div>

			</section>
		</div>
		
		<PrimaryButton class="center" v-if="bioSection.cta" :linkText="bioSection.cta.linkText" :linkURL="bioSection.cta.linkURL"></PrimaryButton>
	
	</div>
	
</template>

<script>
	
	import Bio from './Bio.vue';
	import PrimaryCTA from '../Global/PrimaryCTA.vue';
	import PrimaryButton from '../Global/PrimaryButton.vue';
	
	export default {
		name: 'Bios',
		
		props: ['subtitle', 'title', 'bioSection', 'cta'],
		
		components: {
			Bio,
			PrimaryCTA,
			PrimaryButton
		}
	}
	
</script>